import React, { useState } from 'react';
import { Button } from 'antd';
import { ChevronLeft, ChevronRight, Download, Archive, Pause, Edit } from 'react-feather';
import styles from './stylesSGPDetails.module.css';
import GeographicUserInsights from '../../../CommonComponents/Dashboard/GeographicUserInsights/GeographicUserInsights';
import DashboardLineChart from '../../../CommonComponents/Dashboard/DashboardLineChart/DashboardLineChart';
import CustomDatePicker from '../../../CommonComponents/CustomDatePicker/CustomDatePicker';
import dayjs from 'dayjs';

function SGPDetails({ onBack }) {
    const [dates, setDates] = useState([dayjs().startOf('week'), dayjs().endOf('week')]);

    const handleDateChange = (queryString) => {
        // Handle date change logic here
        console.log('Date changed:', queryString);
    };

    const stakedAmountChartData = {
        labels: ['Aug 20', 'Aug 21', 'Aug 22', 'Aug 23', 'Aug 24', 'Aug 25', 'Aug 26'],
        datasets: [
            {
                label: 'Staked Amount',
                data: [15000, 18000, 22000, 28520, 32000, 28000, 25000],
                borderColor: '#4ade80',
                backgroundColor: 'rgba(74, 222, 128, 0.1)',
                borderWidth: 2,
                fill: true,
                tension: 0.4,
            }
        ],
        headers: [
            { title: "TOTAL BETS", amount: 2044, percentage: 7 },
            { title: "TOTAL AMOUNT", amount: 204099.87, percentage: 10 }
        ]
    }
    const stateData = [
        { name: 'Colorado', amount: 15328 },
        { name: 'California', amount: 15328 },
        { name: 'New York', amount: 15328 },
        { name: 'Florida', amount: 328 },
        { name: 'Texas', amount: 100 },
        { name: 'Arizona', amount: 15328 }
    ];

    return (
        <div className={styles.container}>
            {/* Header */}
            <div className={styles.header}>
                <div className={styles.headerLeft}>
                    <button className={styles.backButton} onClick={onBack}>
                        <ChevronLeft size={20} />
                    </button>
                    <h1>SGP #22329921</h1>
                </div>
                <div className={styles.headerRight}>
                    <div className={styles.navigationControls}>
                        <button className={styles.navButton}>
                            <ChevronLeft size={16} />
                        </button>
                        <div className={styles.datePickerContainer}>
                            <CustomDatePicker
                                getData={handleDateChange}
                                dates={dates}
                                setDates={setDates}
                                showPresets={true}
                                startRange="This Week"
                            />
                        </div>
                        <button className={styles.navButton}>
                            <ChevronRight size={16} />
                        </button>
                    </div>
                    <button className={styles.downloadButton}>
                        <Download size={16} />
                    </button>
                </div>
            </div>

            <div className={styles.content}>
                {/* Left Column - Statistics and Charts */}
                <div className={styles.leftColumn}>
                    {/* Key Metrics */}
                    <div className={styles.metricsSection}>
                        <div className={styles.metricCard}>
                            <div className={styles.metricLabel}>AVG BET AMOUNT</div>
                            <div className={styles.metricValue}>$34.5</div>
                        </div>
                        <div className={styles.metricCard}>
                            <div className={styles.metricLabel}>PROFIT & LOSS</div>
                            <div className={styles.metricValue}>-</div>
                        </div>
                    </div>


                    {/* Staked Amount Graph */}
                    <div className={styles.chartSection}>
                        <DashboardLineChart
                            data={stakedAmountChartData}
                            showCustomDatePicker={false}
                            headers={stakedAmountChartData.headers}
                            isApiRunning={false}
                            setSelected={() => { }}
                            customOptions={false}
                            rightInfo={false}
                        />
                    </div>

                    {/* Bets by States */}
                    <div className={styles.statesSection}>
                        <div className={styles.statesContent}>
                            <GeographicUserInsights
                                data={stateData}
                                isApiRunning={false}
                                title={"Bets by State"}
                            />
                            <div className={styles.statesList}>
                                <div className={styles.statesListHeader}>
                                    <span className={styles.headerStates}>STATES</span>
                                    <span className={styles.headerBets}>BETS</span>
                                </div>
                                {stateData.map((state, index) => (
                                    <div key={index} className={styles.stateItem}>
                                        <span className={styles.stateName}>{state.name}</span>
                                        <span className={styles.stateBets}>{state.amount.toLocaleString()}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Column - Summary and Actions */}
                <div className={styles.rightColumn}>
                    <div className={styles.summaryPanel}>
                        <div className={styles.summaryHeader}>
                            <h3>Summary</h3>
                            <span className={styles.statusBadge}>Pending</span>
                        </div>
                        <div className={styles.underline}></div>
                        <div className={styles.summaryContent}>
                            <div className={styles.summaryItem}>
                                <span className={styles.summaryLabel}>Date</span>
                                <span className={styles.summaryValue}>Oct 05, 2025 8:00 PM</span>
                            </div>
                            <div className={styles.summaryItem}>
                                <span className={styles.summaryLabel}>Match</span>
                                <span className={styles.summaryValue}>Chicago Bulls vs. Sacramento Kings</span>
                            </div>
                            <div className={styles.summaryItem}>
                                <span className={styles.summaryLabel}>Provider</span>
                                <span className={styles.summaryValue}>Sportradar</span>
                            </div>
                            <div className={styles.underline}></div>
                            <div className={styles.summaryTotal}>
                                <div className={styles.summaryItem}>
                                    <span className={styles.summaryLabel}>Total Odds</span>
                                    <span className={styles.summaryValue} style={{ fontSize: '20px' }}>+210</span>
                                </div>
                                <div className={styles.summaryItem}>
                                    <span className={styles.summaryLabel}>Number of Legs</span>
                                    <span className={styles.summaryValue} style={{ fontSize: '20px' }}>3</span>
                                </div>
                            </div>
                        </div>
                        <div className={styles.actionButtons}>
                            <Button className={styles.suspendButton}>
                                <Pause size={16} />
                                Suspend
                            </Button>
                            <Button className={styles.editButton}>
                                <Edit size={16} />
                                Edit
                            </Button>
                        </div>
                        <div className={styles.archiveLink}>
                            <Archive size={16} />
                            Archive
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SGPDetails;

